<script lang="ts">
export default {
    name: 'SidebarBackup',
};
</script>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router/composables';
import i18n from '@/plugins/i18n';
import SidebarNestedSection from '@/components/app/sidebar/section/nested-section.vue';
import PlanCard from '@/components/payments/components/service-plan/components/sidebar-card.vue';
import CreatePopup from '@/components/backup/components/create-popup.vue';
import ConnectionPopup from '@/modules/connection/components/popup.vue';

// @ts-expect-error not typed yet
import { useStore } from '@/store';
// @ts-expect-error not typed yet
import { PRODUCT } from '@/components/payments/components/service-plan/constants.js';

const route = useRoute();
const sectionActive = computed(() => route.matched.some(item => item.meta.section === 'backup'));

const vuex = useStore();

const connection = computed(() => vuex.state.backup.data.source);
const isActiveAuthorization = computed(() => vuex.getters['backup/isAuthorized']);
const isLocked = computed(() => vuex.getters['backup/isLocked']);

const backupPlan = computed(() => vuex.getters['backup/getPlan']);
const isActivePlan = computed(() => backupPlan.value?.status === 'active');

const nestedSections = computed(() => [
    {
        label: i18n.t('backup runs'),
        icon: {
            name: 'database',
            prefix: 'fas',
        },
        route: {
            name: 'backupInstances',
            params: {
                backupId: route.params.backupId,
            },
        },
    },
    {
        label: i18n.t('backup objects'),
        icon: {
            name: 'list-ul',
            prefix: 'fas',
        },
        route: {
            name: 'backupObjects',
            params: {
                backupId: route.params.backupId,
            },
        },
    },
    {
        label: i18n.t('backup exports'),
        icon: {
            name: 'download',
            prefix: 'fas',
        },
        route: {
            name: 'backupExports',
            params: {
                backupId: route.params.backupId,
            },
        },
    },
    {
        label: i18n.t('backup schedule'),
        icon: {
            name: 'calendar-alt',
            prefix: 'far',
        },
        route: {
            name: 'backupSchedule',
            params: {
                backupId: route.params.backupId,
            },
        },
    },
    {
        label: i18n.t('backup pricing'),
        icon: {
            name: 'wallet',
            prefix: 'fas',
        },
        route: {
            name: 'backupPricing',
            params: {
                backupId: route.params.backupId,
            },
        },
    },
    // {
    //     label: 'History',
    //     icon:  {
    //         name:   'history',
    //         prefix: 'fas',
    //     },
    //     route: {
    //         name:   'backupHistory',
    //         params: {
    //             backupId: route.params.backupId,
    //         },
    //     },
    // },
]);

const showCreatePopup = ref(false);
const showConnectionPopup = ref(false);

const emit = defineEmits({
    navigate: null,
});
</script>

<template>
    <sidebar-nested-section
        :title="$t('home backups title')"
        :tooltip="$t('home backups title')"
        :go-back-title="$t('backup back to list')"
        :go-back-title-tooltip="$t('backup back to list')"
        :create-title="$t('backup create')"
        :reconnect-title="$t('backup reconnect')"
        section-name="backup"
        section-route="backupList"
        :section-active="sectionActive"
        :section-icon="{ name: 'database' }"
        :nested-sections="nestedSections"
        :is-active-authorization="!!isActiveAuthorization"
        :is-locked="isLocked"
        :loading="!connection"
        @create="showCreatePopup = true"
        @navigate="emit('navigate')"
        @reconnect="showConnectionPopup = true"
    >
        <template #under-section>
            <plan-card
                v-if="isActivePlan"
                :plan="backupPlan"
                :product="PRODUCT.BACKUP"
                :pricing-route="{
                    name: 'backupPricing',
                    params: {
                        id: route.params.backupId,
                    },
                }"
            />
            <create-popup
                v-if="backupPlan"
                :show="showCreatePopup"
                @closePopup="showCreatePopup = false"
            />
            <connection-popup
                v-model="showConnectionPopup"
                :connection="connection"
                :connection-link-data="() => ({
                    id: connection.id,
                    direction: 'source',
                    origin: 'backup',
                })"
                type="source"
                locked
            />
        </template>
    </sidebar-nested-section>
</template>
